import React from "react";
import { IoReturnDownBack } from "react-icons/io5";

function NotFoundPage() {
  return (
    <div className="min-h-screen bg-gsf-sage flex items-center justify-center p-4 font-sans selection:bg-gsf-sand">
      {/* ─── CONTAINER BOARD WINDOW ─── */}
      <main className="w-full max-w-xl border-4 border-slate-900 bg-white rounded-3xl p-6 lg:p-10 shadow-[12px_12px_0px_0px_#ccd5ae] relative overflow-hidden bg-grid-pattern transition-all duration-300 hover:shadow-[16px_16px_0px_0px_#d4a373]">
        {/* Top Window Bar ala Terminal */}
        <div className="absolute top-0 left-0 right-0 border-b-4 border-slate-900 bg-gsf-sand/40 px-4 py-2 flex items-center justify-between select-none">
          <div className="flex gap-1.5">
            <span className="w-2.5 h-2.5 rounded-full bg-red-400 border border-slate-900 animate-pulse"></span>
            <span className="w-2.5 h-2.5 rounded-full bg-slate-200 border border-slate-900"></span>
            <span className="w-2.5 h-2.5 rounded-full bg-slate-200 border border-slate-900"></span>
          </div>
          <p className="font-mono text-[10px] font-black uppercase tracking-wider text-slate-500">
            STDOUT::ERROR_404
          </p>
        </div>

        {/* Konten Utama */}
        <div className="text-center pt-8 pb-4 space-y-6 relative z-10">
          {/* Angka Gede Fantastis */}
          <div className="relative inline-block select-none">
            <h1 className="text-7xl sm:text-8xl font-black text-slate-900 tracking-tighter drop-shadow-[4px_4px_0px_#faedcd]">
              404
            </h1>
            <span className="absolute -top-1 -right-4 border-2 border-slate-900 bg-white px-2 py-0.5 text-[9px] font-mono font-black uppercase tracking-widest text-gsf-bronze rounded shadow-[1.5px_1.5px_0px_0px_#ccd5ae] rotate-12">
              Route Missing
            </span>
          </div>

          {/* Sub-Headline & Deskripsi */}
          <div className="space-y-2">
            <h2 className="text-xl sm:text-2xl font-black text-slate-900 tracking-tight">
              Endpoint Not Deployed[cite: 1, 4, 5]
            </h2>
            <p className="text-xs sm:text-sm text-slate-600 font-medium max-w-sm mx-auto leading-relaxed">
              The requested routing node does not exist in Gunjo's production
              infrastructure cluster.[cite: 1, 4] It might still be compiling in
              the pipeline.
            </p>
          </div>

          {/* Simfoni Kode Visual Board ala Terminal Card Sisi Kanan Hero */}
          <div className="border-2 border-slate-900 bg-gsf-cream/30 rounded-xl p-4 text-left font-mono text-[11px] leading-relaxed text-slate-700 relative overflow-hidden shadow-[3px_3px_0px_0px_#faedcd]">
            <div className="text-slate-400 select-none border-b border-slate-900/10 pb-1 mb-1">
              // Runtime Trace Diagnostics
            </div>
            <p>
              <span className="text-gsf-bronze font-bold">&gt;</span>{" "}
              request_uri:{" "}
              <span className="text-slate-900 font-semibold">
                window.location.pathname
              </span>
            </p>
            <p>
              <span className="text-gsf-bronze font-bold">&gt;</span>{" "}
              status_code:{" "}
              <span className="text-red-500 font-bold">404_NOT_FOUND</span>
            </p>
            <p>
              <span className="text-gsf-bronze font-bold">&gt;</span> Action:
              redirect_to_safety()
            </p>
          </div>

          {/* Navigasi Balik Ke Safety */}
          <div className="pt-2">
            <a
              href="/"
              className="inline-flex items-center justify-center w-full border-2 border-slate-900 bg-slate-900 py-3 font-bold text-xs uppercase tracking-wider text-white rounded-xl shadow-[4px_4px_0px_0px_#faedcd] transition-all duration-200 hover:-translate-y-0.5 hover:shadow-[6px_6px_0px_0px_#d4a373] active:translate-y-0"
            >
              <div className="flex gap-2 items-center">
                <IoReturnDownBack className="text-xl" /> Return to Core
                Ecosystem
              </div>
            </a>
          </div>
        </div>

        {/* Dekorasi Kode Mini di Dasar Kartu */}
        <div className="absolute bottom-2 right-4 font-mono text-[8px] text-slate-400 select-none">
          err_handler.go // line 404[cite: 1, 4]
        </div>
      </main>
    </div>
  );
}

export default NotFoundPage;
